import {
  APP_PAGES_LIST_REQUEST,
  APP_PAGES_LIST_SUCCESS,
  APP_PAGES_LIST_FAIL,
  APP_PAGE_GET_REQUEST,
  APP_PAGE_GET_SUCCESS,
  APP_PAGE_GET_FAIL,
  APP_PAGE_CREATE_REQUEST,
  APP_PAGE_CREATE_SUCCESS,
  APP_PAGE_CREATE_FAIL,
  APP_PAGE_UPDATE_REQUEST,
  APP_PAGE_UPDATE_SUCCESS,
  APP_PAGE_UPDATE_FAIL,
  APP_PAGE_DELETE_REQUEST,
  APP_PAGE_DELETE_SUCCESS,
  APP_PAGE_DELETE_FAIL,
  APP_PAGE_VERSIONS_REQUEST,
  APP_PAGE_VERSIONS_SUCCESS,
  APP_PAGE_VERSIONS_FAIL,
  APP_PAGE_RESTORE_REQUEST,
  APP_PAGE_RESTORE_SUCCESS,
  APP_PAGE_RESTORE_FAIL,
} from "./appPageTypes";

const initialState = {
  pages: [],
  currentPage: null,
  requestedPageId: null,
  versions: [],
  loading: false,
  error: null,
};

export const appPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_PAGE_GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentPage: null,
        requestedPageId: action.payload,
      };

    case APP_PAGES_LIST_REQUEST:
    case APP_PAGE_CREATE_REQUEST:
    case APP_PAGE_UPDATE_REQUEST:
    case APP_PAGE_DELETE_REQUEST:
      return { ...state, loading: true, error: null };

    case APP_PAGES_LIST_SUCCESS:
      return { ...state, loading: false, pages: action.payload };

    case APP_PAGE_GET_SUCCESS:
      if (action.meta?.pageId && action.meta.pageId !== state.requestedPageId) return state;
      return {
        ...state,
        loading: false,
        currentPage: action.payload,
        requestedPageId: null,
      };

    case APP_PAGE_CREATE_SUCCESS:
      return { ...state, loading: false, pages: [...state.pages, action.payload] };

    case APP_PAGE_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPage: action.payload,
        pages: state.pages.map((p) => (p._id === action.payload._id ? action.payload : p)),
      };

    case APP_PAGE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        pages: state.pages.filter((p) => p._id !== action.payload),
      };

    case APP_PAGE_VERSIONS_SUCCESS:
      return { ...state, loading: false, versions: action.payload };

    case APP_PAGE_RESTORE_SUCCESS:
      return { ...state, loading: false, currentPage: action.payload };

    case APP_PAGE_GET_FAIL:
      if (action.meta?.pageId && action.meta.pageId !== state.requestedPageId) return state;
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentPage: null,
        requestedPageId: null,
      };

    case APP_PAGES_LIST_FAIL:
    case APP_PAGE_CREATE_FAIL:
    case APP_PAGE_UPDATE_FAIL:
    case APP_PAGE_DELETE_FAIL:
    case APP_PAGE_VERSIONS_FAIL:
    case APP_PAGE_RESTORE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case APP_PAGE_VERSIONS_REQUEST:
    case APP_PAGE_RESTORE_REQUEST:
      return { ...state, loading: true, error: null };

    default:
      return state;
  }
};
